import { useState, useEffect } from 'react';

function useLocationHook() {
  const [currentLastUrl, setCurrentLastUrl] = useState(null);

  useEffect(() => {
    const url = document.location.href;
    const splitUrl = url.split('/');
    const location = splitUrl[splitUrl.length - 1];
    setCurrentLastUrl(location);
  });

  return currentLastUrl;
}

export default useLocationHook;
